<template>
  <nav
    ref="navBar"
    :class="{
      navbar: true,
      Home: transparentNav && navBarVisbilityClass === 'hide',
    }"
  >
    <div class="logoContainer wow bounceIn">
      <router-link to="/">
        <img
          :src="
            transparentNav && navBarVisbilityClass === 'hide'
              ? whiteImage
              : blackImage
          "
          alt="logo"
          loading="lazy"
          draggable="false"
        />
      </router-link>
    </div>

    <ul
      :class="noneDisplay + ' ' + navBarVisbilityClass"
      @animationend="animationEnd"
    >
      <li v-for="title in titles" :key="title">
        <router-link
          active-class="active"
          :class="{
            active: projectNestedRoute && title.route === '/projects',
          }"
          exact
          :to="title.route"
          >{{ title.name }}</router-link
        >
      </li>
    </ul>
    <div class="toggleIcon">
      <i
        :class="{
          'fa fa-stream':
            navBarVisbilityClass === 'hide' || navBarVisbilityClass === '',
          'fa fa-times': navBarVisbilityClass === 'show',
        }"
        @click="toggleNavBarVisibility"
      />
    </div>
  </nav>
</template>

<script>
import store from "@/store";
import balckLogo from "@/assets/blackLogo.webp";
import whiteLogo from "@/assets/whiteLogo.png";
export default {
  name: "NavBar",
  data: function () {
    return {
      whiteImage: whiteLogo,
      blackImage: balckLogo,
      navBarVisbilityClass: "hide",
      noneDisplay: "hidden",
      transparentNav: true,
      projectNestedRoute: false,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  unmounted() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  computed: {
    titles() {
      const { lang } = store.state;
      return store.state[lang].navbarTitles;
    },
  },
  methods: {
    toggleNavBarVisibility() {
      window.scrollTo(0, 0);
      const { navBarVisbilityClass } = this;
      if (navBarVisbilityClass === "show") {
        this.$refs["navBar"].style.zIndex = "1000";
        this.navBarVisbilityClass = "hide";
        document.body.style.overflow = "auto";
      } else {
        document.body.style.overflow = "hidden";
        this.$refs["navBar"].style.zIndex = "5000";
        this.navBarVisbilityClass = "show";
        this.noneDisplay = "";
      }
    },
    animationEnd() {
      if (this.navBarVisbilityClass === "hide") {
        this.noneDisplay = "hidden";
      }
    },
    handleScroll() {
      if (window.scrollY > 50) {
        this.transparentNav = false;
      } else {
        this.transparentNav = true;
      }
    },
  },
  watch: {
    $route(to) {
      document.body.style.overflow = "auto";
      this.$refs["navBar"].style.zIndex = "1000";
      if (
        to.name == "Home" ||
        to.name == "Contact" ||
        to.name == "ProjectPage" ||
        to.name == "NotFound"
      ) {
        this.transparentNav = true;
        window.addEventListener("scroll", this.handleScroll);
      } else {
        this.transparentNav = false;
        window.removeEventListener("scroll", this.handleScroll);
      }
      if (to.name == "ProjectPage") {
        this.projectNestedRoute = true;
      } else {
        this.projectNestedRoute = false;
      }
      const { navBarVisbilityClass } = this;
      if (navBarVisbilityClass === "show") {
        this.navBarVisbilityClass = "hide";
      }
    },
  },
};
</script>
